import { createI18n } from 'vue-i18n'
import es from './locales/es.json'
import en from './locales/en.json'

function getBrowserLocale() {
  const browserLocale = navigator.language || navigator.userLanguage
  const shortLocale = browserLocale.split('-')[0]
  return ['es', 'en'].includes(shortLocale) ? shortLocale : 'es'
}

const savedLocale = localStorage.getItem('locale')
const initialLocale = savedLocale || getBrowserLocale()

const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: 'es',
  messages: { es, en }
})

export default i18n
